module.exports = __webpack_public_path__ + "static/media/deposit-icon.2b51e513.svg";